export const formatNumber = (price: number, maximumFractionDigits = 2): string => {
   return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits,
   }).format(price);
};
